export enum GeneralActor {
    SpecificPerson = -1,
    System = 0,
    CorporateHR = 1,
    LocalHR = 2,
    Employee = 3,
    Manager = 33,
    Delegate = 333,
    Matrix = 3333,
    N2 = 4,
    Peer = 5,
    Trainer = 6,
    OtherEmployee = 7,
    Candidate = 8,
    Interval = 10,
    API = 11,
    FixedEmailAddressManualInput = 15,
    CompanyEmailAddressId = 16,
    ConversationOtherReceivers = 17,
}